import { render, staticRenderFns } from "./HistoryNorthData.vue?vue&type=template&id=a52fa8dc"
import script from "./HistoryNorthData.vue?vue&type=script&lang=js"
export * from "./HistoryNorthData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports